import React from "react";
import { Store, Database, Puzzle } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "AI-First Delivery",
  description: "Harnessing computational intelligence to modernize enterprise architecture with unprecedented speed, removing legacy friction through automated intelligence.",
  icon: Store
}, {
  title: "Outcome-Led Execution",
  description: "Turning strategic vision into measurable performance. We focus on high-impact initiatives that optimize revenue, reduce cost, and drive operational excellence.",
  icon: Database
}, {
  title: "Secure-by-Design",
  description: "Cybersecurity is integrated into every system from day one. Enterprise-grade governance and defense powered by our strategic partnership with Cytrusst.",
  icon: Puzzle
}];
export default function TheEtlobEdge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="16872" id="the-quantificial-edge" className="relative w-full py-24 overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-chart-1/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-chart-2/5 rounded-full blur-3xl" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-sans tracking-tight text-foreground mb-4">
            The Quantificial Edge
          </h2>
          <p className="text-lg text-muted-foreground font-medium">
            Empowering enterprise leaders and private equity firms to transform complex systems into high-performance, intelligent assets.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, i) => <div key={i} data-index={i} className="group h-full">
              <Card className="h-full border-0 border-t-[1px] border-t-chart-1 bg-card/50 backdrop-blur-sm shadow-sm transition-all duration-500 hover:bg-gradient-to-br hover:from-background hover:to-chart-1/5 hover:-translate-y-2 hover:shadow-xl">
                <CardHeader className="pb-2">
                  <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-lg bg-gradient-to-br from-background to-muted shadow-sm border border-border/40 group-hover:scale-105 transition-transform duration-500">
                    <feature.icon className="w-8 h-8 text-chart-1 drop-shadow-sm" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl font-bold font-sans text-foreground group-hover:text-chart-1 transition-colors">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed text-muted-foreground group-hover:text-foreground transition-colors">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}